<template>
    <v-dialog v-model="dialog" fullscreen>
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Extraction Entry</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row >
                        <v-col cols="12" v-if="specimen.Aggressive">
                            <v-alert
                                :value="true"
                                color="error"
                                type="error"
                                outlined
                            >
                                <span>Specimen is flagged as aggressive.</span>
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pr-2" cols="3">
                            <p><strong>Specimen ID:</strong> {{specimen.SpecimenDisplayID}}</p>
                            <p><strong>Rack:</strong> {{specimen.RackNumber}}</p>
                        </v-col>
                        <v-col class="pr-2" cols="3">
                            <p :class="`${specimenSpeciesClass}`"><strong>Species:</strong> {{specimen.SpeciesFullName}}</p>
                            <p  :class="`${specimenRoomClass}`"><strong>Room:</strong> {{specimen.RoomText}}</p>
                        </v-col>
                        <v-col class="pl-2" cols="6">
                            <v-textarea dense :rows="3" label="Permanent Notes" background-color="error lighten-5" hide-details counter="2000" v-model="specimen.PermanentNotes"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col class="pr-2" :class="{'d-none' : action == 'UPDATE' }" cols="6">
                            <v-progress-linear indeterminate v-if="loadingHistoricForm"></v-progress-linear>
                            <DailyHusbandryExtractionFormBase :formData="previousForm" v-if="!loadingHistoricForm && previousForm != null" :disabled="true"></DailyHusbandryExtractionFormBase>
                            <v-alert type="warning" v-if="!loadingHistoricForm && previousForm == null">There is no historic extraction for this specimen</v-alert>
                        </v-col>
                        <v-col class="pl-2" :class="{'d-none' : action == 'UPDATE' }" cols="6">
                            <DailyHusbandryExtractionFormBase :formData="currentForm"></DailyHusbandryExtractionFormBase>
                        </v-col>
                        <v-col class="pl-2" :class="{'d-none' : action == 'INSERT' }" cols="12" d-none="true">
                            <v-progress-linear indeterminate v-if="loadingHistoricForm"></v-progress-linear>
                            <DailyHusbandryExtractionFormBase :formData="previousForm" v-if="!loadingHistoricForm && previousForm != null"></DailyHusbandryExtractionFormBase>
                        </v-col>
                        <v-col class="pr-2" cols="6">
                        </v-col>
                        <v-col class="pr-2" cols="6">
                            <v-btn 
                                block
                                color="success"
                                :loading="saving"
                                :disabled="!valid || saving"
                                @click="save">Save</v-btn>
                        </v-col>
                        <v-col class="pr-2" cols="6">
                        </v-col>
                        <v-col class="pr-2" cols="6">
                            <v-btn
                                block
                                color="accent"
                                @click="
                                    openHusbandry(
                                        specimen.SpecimenDisplayID
                                    )
                                "
                            >
                                Husbandry
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import DailyHusbandryExtractionFormBase from "@/components/venompooling/DailyHusbandryExtractionFormBase.vue";
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import moment from "moment";

export default {
    components: {
        DailyHusbandryExtractionFormBase
    },
    props: {
        primaryExtractor: {
            type: String,
            default: ""
        },
        secondaryExtractor: {
            type: String,
            default: ""
        },
        dailyExtractionSession: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            dialog: false,

            loadingHistoricForm: false,

            previousForm: {},
            currentForm: {},
            specimen: {},

            saving: false,
            saveError: "",

            action:"",
            fullscreen:true,
            width:""
        }
    },
    computed: {
        specimenSpeciesClass() {
            if (
                this.specimen.SpeciesID != this.dailyExtractionSession.SpeciesID
            ) {
                return "specimen-warning";
            } else {
                return "";
            }
        },
        specimenRoomClass() {
            if (this.specimen.RoomID != this.dailyExtractionSession.RoomID) {
                return "specimen-warning";
            } else {
                return "";
            }
        },
        valid() {
            return this.currentForm.VenomCollected ||
                (!this.currentForm.VenomCollected && this.currentForm.CollectionComment != "");
        },
    },
    methods: {
        showDialog(specimen,action) {
            this.specimen = specimen;
            this.action = action;
            if(this.action === "INSERT"){
                this.loadHistoricExtraction();
            }else{
                this.previousForm = specimen;
            }


            this.currentForm = {
                SpecimenID: specimen.SpecimenID,
                DailyExtractionSessionID: this.dailyExtractionSession.DailyExtractionSessionID,
                VenomCollected: true,
                CollectionComment: "",
                PrimaryExtractorEmail: this.primaryExtractor,
                AssistantEmail: this.secondaryExtractor,
                RecordedAt: moment().toDate(),
                Funnel180: "",
                FunnelBite: "",
                FunnelBiteTime: "",
                FunnelBulldog: "",
                FunnelChewing: "",
                FunnelClimbing: "",
                FunnelHolding: "",
                FunnelMXPercentOfVenomCollected: "",
                FunnelPulse: "",
                FunnelStabbing: "",
                PinAnglePullAborted: ""

            }

            if(specimen.DailyExtractionSessionEntryID){
                this.currentForm.DailyExtractionSessionEntryID = specimen.DailyExtractionSessionEntryID;
            }

            this.dialog = true;
        },
        async loadHistoricExtraction() {
            this.loadingHistoricForm = true;

            this.previousForm = await venomPoolingAPI.getLatestExtractionSessionData(this.specimen.SpecimenID);
            
            this.loadingHistoricForm = false;
            
        },
        async save() {
            this.saving = true;
            this.saveError = "";

            try {
                                
                if(this.action == "INSERT"){

                    this.currentForm.PermanentNotes = this.specimen.PermanentNotes;
                    this.currentForm.action = this.action;
                    await venomPoolingAPI.createDailyExtractionSessionEntry(this.currentForm);
                }
                else{

                    this.previousForm.PermanentNotes = this.specimen.PermanentNotes;
                    this.previousForm.action = this.action;
                    //remove property not in the dailyExtractionSessionEntries Tbale
                    let {SpecimenDisplayID,HusbandryPerformed,PrimaryExtractorUserFirstName,PrimaryExtractorUserLastName,
                    AssistantUserFirstName, AssistantUserLastName,GeographicalLocationName,...restRecords} = this.previousForm;
                    await venomPoolingAPI.updateDailyExtractionSessionEntry(restRecords);
                }

                this.$emit("recorded");

                this.dialog = false;
            } catch (e) {
                this.saveError = e.message;
            }

            this.saving = false;
        },

        openHusbandry(id) {
            let routeData = this.$router.resolve({
                name: "husbandrywithid",
                params: { specimenDisplayID: id },
            });
            window.open(routeData.href, "_blank");
        },
    },
    created() {
        
    }
}
</script>

<style scoped>
.specimen-warning {
    color: red;
}
</style>